// extracted by mini-css-extract-plugin
export default {"tooltip":"Gu-z","sharingV2":"Hu-z","sharingIconsV2":"Iu-z","links":"Ju-z","link":"Ku-z","facebookV2":"Lu-z","twitterV2":"Mu-z","pinterestV2":"Nu-z"};